<template>
  <div class="page_footer">
    <div class="container">
      <div class="logoContainer">
        <img src="../assets/images/staticPage/homePage/bottomLogo1.png" alt="">
        <img src="../assets/images/staticPage/homePage/bottomLogo2.png" alt="">
        <img src="../assets/images/staticPage/homePage/bottomLogo3.png" alt="">
        <img src="../assets/images/staticPage/homePage/bottomLogo4.png" alt="">
        <img src="../assets/images/staticPage/homePage/bottomLogo5.png" alt="">
        <img src="../assets/images/staticPage/homePage/bottomLogo6.png" alt="">
      </div>
      <!-- <div class="navList_">
        <div class="list" v-for="item in pageData.navList" :key="item">
          <div class="title">
            {{ item.name }}
          </div>
          <div class="container">
            <div v-for="items in item.list" :key="items">
              {{ items.name }}
            </div>
          </div>
        </div>
      </div> -->
    </div>

  </div>
</template>

<script>
import { reactive } from "vue";
// import { useRoute, useRouter } from "vue-router";
// import { useStore } from "vuex";
// import Cookies from "js-cookie";

export default {
  name: "navigation",
  setup(prop) {
    console.log(prop);
    // const route = useRoute();
    // const router = useRouter();
    // const store = useStore();
    let pageData = reactive({
      navList: [
        {
          name: "龙源",
          list: [
            {
              name: "龙源大事记",
              path: ''
            },
            {
              name: "在线支付",
              path: ''
            },
            {
              name: "常见问题",
              path: ''
            }
          ]
        },
        {
          name: "关于龙源",
          list: [
            {
              name: "开具发票",
              path: ''
            },
            {
              name: "诚聘英才",
              path: ''
            },
            {
              name: "会员咨询/投诉",
              path: ''
            }
          ]
        },
        {
          name: "网络信息举报",
          list: [
            {
              name: "关于我们",
              path: ''
            },
            {
              name: "购买流程",
              path: ''
            }
          ]
        },
        {
          name: "客服中心",
          list: [
            {
              name: "关于我们",
              path: ''
            },
            {
              name: "购买流程",
              path: ''
            }
          ]
        },
        {
          name: "商务合作",
          list: [
            {
              name: "常见问题",
              path: ''
            },
            {
              name: "龙源大事记",
              path: ''
            }
          ]
        },
      ]
    })
    return {
      pageData
    };
  },
};
</script>
<style lang='scss' scoped>
.page_footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 42px 0 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  background: #F5F7FA;
  overflow: hidden;
  // margin-bottom: 50px;
  .container {
    width: 1380px;

    .navList_ {
      width: 100%;
      display: flex;
      align-items: flex-start;
      margin-top: 43px;
      .list {
        width: 200px;

        .container {
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #909399;
          line-height: 20px;
          div{
            cursor: pointer;
          }
        }

        .title {
          font-size: 15px;
          font-family: AlibabaPuHuiTiM;
          color: #303133;
          font-weight: 700;
          margin-bottom: 10px;
        }
      }
    }

    .logoContainer {
      display: flex;
      justify-content: space-between;

      img {
        height: 24px;
        margin-right: 66px;
      }

      img:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
